// extracted by mini-css-extract-plugin
export var lFooter = "sa";
export var lFooter__inner = "ta";
export var lFooter__copyright = "ua";
export var animationMarquee = "va";